<script setup lang="ts">
import type {ArticleAsset} from '@/types';
import {HomeFeature, HomeFeatureTile, HomeFeatureContent, HomeFeatureContentLogo, HomeFeatureContentBody} from '@/lib/ui/home-feature';

const {translate} = useTranslation();
const data = ref();

if (import.meta.client) {
  const {data: lazyResp, error} = await useLazyFetch<ArticleAsset>(`/api/asset-by-slug?slug=icandy-experience&status=${window ? (window.location !== window.parent.location ? 'draft' : 'published') : 'published'}`, {server: false});

  if (lazyResp.value && !error) {
    data.value = lazyResp.value as ArticleAsset;
  }

  watch(lazyResp, () => {
    data.value = lazyResp.value as ArticleAsset;
  });
}
</script>

<template>
  <HomeFeature class="bg-[var(--icandy-color-lighter)]">
    <template v-if="data">
      <HomeFeatureTile class="icandy-feature-tile__override">
        <img :src="data.fields.feature_image.public_url" alt="iCandy Feature" />

        <img :src="data.fields.feature_icon.public_url" alt="iCandy Logo" class="mobile-only" />
      </HomeFeatureTile>

      <HomeFeatureContent class="bg-[var(--icandy-color-lighter)] bg-[url('/assets/icandy/icandy-feature-bground.png')] bg-center bg-cover">
        <HomeFeatureContentLogo :reverse="true">
          <img :src="data.fields.feature_icon.public_url" alt="iCandy Logo" class="max-w-[450px] m-auto" />
        </HomeFeatureContentLogo>

        <HomeFeatureContentBody>
          <h3 class="!text-[var(--icandy-color)]" v-html="translate(data.fields.sub_title)" />
          <p class="flex flex-col gap-[3rem] !text-[var(--icandy-color)]" v-html="translate(data.fields.content)" />

          <ul class="flex gap-[1.5rem]">
            <li>
              <TheButton tag="NuxtLink" class="!bg-[var(--icandy-color)] !border-none !py-4 w-[270px] hover:!bg-black hover:!text-white" to="https://www.icandynyc.com/" target="_blank">Tickets &amp; Info</TheButton>
            </li>
          </ul>
        </HomeFeatureContentBody>
      </HomeFeatureContent>
    </template>
  </HomeFeature>
</template>
